export default "__VITE_PUBLIC_ASSET__feb0fee0__"